'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function CTASection() {
    const [isHydrated, setIsHydrated] = useState(false);

    useEffect(() => {
        setIsHydrated(true);
    }, []);

    if (!isHydrated) {
        return (
            <section className="py-20 bg-background">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="h-64 bg-surface rounded-xl animate-pulse" />
                </div>
            </section>
        );
    }

    return (
        <section className="py-20 bg-background">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="relative overflow-hidden rounded-2xl">
                    <div className="absolute inset-0 bg-gradient-to-br from-primary via-accent to-success opacity-10" />
                    <div className="absolute inset-0">
                        <div className="absolute top-0 left-0 w-96 h-96 bg-primary/20 rounded-full blur-3xl" />
                        <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent/20 rounded-full blur-3xl" />
                    </div>

                    <div className="relative glass glass-border p-12 sm:p-16 lg:p-20 text-center">
                        <div className="inline-flex items-center space-x-2 glass glass-border px-4 py-2 rounded-full mb-6">
                            <Icon name="RocketLaunchIcon" size={20} variant="solid" className="text-accent" />
                            <span className="text-sm font-medium text-text-secondary">Join 100+ Learners</span>
                        </div>

                        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-text-primary mb-6">
                            Ready to Transform Your
                            <br />
                            <span className="gradient-text">Learning Journey?</span>
                        </h2>

                        <p className="text-xl text-text-secondary max-w-3xl mx-auto mb-12 leading-relaxed">
                            Experience the future of education with AI-powered personalization, sophisticated design, and measurable results.
                        </p>

                        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                            <Link
                                href="/contact"
                                className="relative px-8 py-4 text-lg font-semibold text-white rounded-lg overflow-hidden group focus-ring w-full sm:w-auto"
                            >
                                <div className="absolute inset-0 bg-gradient-to-r from-primary via-accent to-success opacity-100 group-hover:opacity-90 transition-opacity" />
                                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity shadow-glow" />
                                <span className="relative z-10 flex items-center justify-center space-x-2">
                                    <span>Contact Us</span>
                                    <Icon name="ArrowRightIcon" size={20} variant="outline" />
                                </span>
                            </Link>

                            <Link
                                href="/for-colleges"
                                className="px-8 py-4 text-lg font-semibold text-text-primary glass glass-border rounded-lg hover:bg-surface-hover transition-smooth focus-ring w-full sm:w-auto"
                            >
                                Schedule Demo
                            </Link>
                        </div>


                    </div>
                </div>
            </div>
        </section>
    );
}